export const AllTransactionColumns = [
    {
        Header: "Description",
        accessor: "description",
    },
    {
        Header: "Transaction ID",
        accessor: "transactionId",
    },
    {
        Header: "Type",
        accessor: "type",
    },
    {
        Header: "Card",
        accessor: "card",
    },
    {
        Header: "Date",
        accessor: "date",
    },
    {
        Header: "Amount",
        accessor: "amount",
    },
    {
        Header: "Receipt",
        accessor: "receipt",
    },
]

export const AllTransactionTableData = [
    {
        description: "Clover",
        transactionId: "#10548796",
        type: "Transfer",
        card: "1234 ****",
        date: "20 Jan, 09.30 AM",
        amount: "-$2,500",
        amountColor: "text-danger",
    },
    {
        description: "Elodie",
        transactionId: "#12548796",
        type: "Shopping",
        card: "5237 ****",
        date: "28 Jan, 12.30 AM",
        amount: "-$2,500",
        amountColor: "text-danger",
    },
    {
        description: "Emilly",
        transactionId: "#16548796",
        type: "Services",
        card: "7567 ****",
        date: "02 Jan, 01.30 AM",
        amount: "+$2,500",
        amountColor: "text-success",
    },
    {
        description: "Felix",
        transactionId: "#14548706",
        type: "Transfer",
        card: "7654 ****",
        date: "22 Jan, 11.30 AM",
        amount: "-$2,500",
        amountColor: "text-danger",
    },
    {
        description: "Wilson",
        transactionId: "#12548796",
        type: "Transfer",
        card: "3418 ****",
        date: "	28 Jan, 12.30 AM",
        amount: "+$2,500",
        amountColor: "text-success",
    },
]
